import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Auth0Provider } from "@auth0/auth0-react";
import { App } from './App';
import { MemoryRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <MemoryRouter>
    <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN!}
    clientId={process.env.REACT_APP_AUTH0_CLIENTID!}
    authorizationParams={{
      redirect_uri: window.location.origin,
      useRefreshTokens: true,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: process.env.REACT_APP_AUTH0_SCOPE,
      cacheLocation: 'localstorage'
    }}
  >
      <App />
    </Auth0Provider>
  </MemoryRouter>
);


